<template>
    <div class="contrast-page">
        <!-- 1、顶部菜单栏 -->
        <div class="discuss-title-bar-normal contrast-page-title-bar dsp-flex">
            <div class="title-side title-gray detail-title-left">
                <span class="title-back discuss-title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="title-middle">
                <span>{{contrastData.f_title}}</span>
            </div>
            <div class="title-side contrast-checkbox">
                <van-checkbox v-model="contrastTimeInteracted" @change="timeInteractChange">时间联动</van-checkbox>
            </div>
        </div> 
        <!-- 2、对比详情的列表 -->
        <div class="contrast-page-list-box">
            <div class="contrast-page-list clearfix" :class="{'contrast-page-list-two': contrastFFStoreList.length == 2}">
                <contrast-item v-for="(cStoreData, cIndex) in contrastFFStoreList" v-bind:key="cStoreData.state.id" :source="cStoreData.state" :itemIndex="cIndex" v-bind:class="{'contrast-item-two': contrastFFStoreList.length == 2, 'contrast-item-no-fortune' : !contrastShowFortune}"></contrast-item>
            </div>
        </div>
        <!-- 3、底部菜单栏 -->
        <div v-if="contrastShowItemDelete" class="contrast-bottom-bar">
            <div class="contrast-bottom-item item-three" @click="clickCancelDelete">退出删除界面</div>
        </div>
        <div v-else-if="contrastShowCommentContent" class="contrast-bottom-comment-content">
            <div class="contrast-bottom-content-title dsp-flex">
                <div class="contrast-bottom-item item-four" @click="clickContentBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </div>
                <div class="contrast-bottom-item item-middle"></div>
                <div class="contrast-bottom-item item-four" @click="clickContentEdit">
                    <span>编辑</span>
                </div>
            </div>
            <div class="contrast-bottom-content-content">
                <p v-html="UTILS.getBreakLineByText(contrastData.f_content)"></p>
            </div>
        </div>
        <contrast-content-edit-panel 
            v-else-if="contrastShowCommentEdit"
            v-bind:textValue="contrastData.f_content">
        </contrast-content-edit-panel>
        <div v-else class="contrast-bottom-bar dsp-flex">
            <div class="contrast-bottom-item item-one" @click="clickAdd">
                <i class="iconfont icon-plus"></i>添加
            </div>
            <div class="contrast-bottom-item item-one" @click="clickDelete">
                <i class="iconfont icon-sub"></i>删除
            </div>
            <div class="contrast-bottom-item item-one" @click="clickEdit">
                <i class="iconfont icon-pizhu"></i>批注
            </div>
            <div class="contrast-bottom-item item-two contrast-checkbox">
                <van-checkbox v-model="contrastShowFortune" @change="fortuneCheckedChange">显示大运</van-checkbox>
            </div>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import { CONTRAST_DOM } from '../../modules/dom';
import ContrastItem from '../../components/contrast/ContrastItem.vue'
import ContrastContentEditPanel from '../../layouts/contrast/ContrastContentEditPanel.vue'
export default {
    name: 'Contrast',
    components: { ContrastItem, ContrastContentEditPanel },
    computed: {
        contrastData() {
            return this.$store.state.contrast.contrastData;
        },
        contrastDetailList() {
            return this.$store.state.contrast.contrastDetailList;
        },
        contrastFFStoreList() {
            return this.$store.state.contrast.contrastFFStoreList;
        },
        contrastTimeInteracted: {
            get() {
                return this.$store.state.contrast.contrastTimeInteracted;
            },
            set(value) {
                this.$store.state.contrast.contrastTimeInteracted = value;
            }
        },
        contrastShowFortune: {
            get() {
                return this.$store.state.contrast.contrastShowFortune;
            },
            set(value) {
                this.$store.state.contrast.contrastShowFortune = value;
            }
        },
        contrastShowItemDelete() {
            return this.$store.state.contrast.contrastShowItemDelete;
        },
        contrastShowCommentContent() {
            return this.$store.state.contrast.contrastShowCommentContent;
        },
        contrastShowCommentEdit() {
            return this.$store.state.contrast.contrastShowCommentEdit;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            timeInteractChecked: false,
            fortuneChecked: false
        }
    },
    mounted: function() {
        let fromPage = this.$store.state.contrast.contrastFromPage;
            fromPage = fromPage ? fromPage : 'collate';
        console.log('contrast-mounted----fromPage=', fromPage);
        if(!this.contrastData || !this.contrastData.id) {
            this.$router.replace('/contrastlist/'+fromPage);
            return;
        }
        setTimeout(() => {
            CONTRAST_DOM.updateContrastPage();
            MIX.trackPageViewed('CompareDetailPage');
        }, 20);
    },
    methods: {
        clickBack() {
            this.$store.dispatch('contrast/resetContrastData');
            let curParams = this.$router.history.current.params;
            let fromPage = curParams ? curParams.frompage : '';
            let detailData = this.$store.state.detail.personInfo;
            let cFromPage = this.$store.state.contrast.contrastFromPage;
                cFromPage = cFromPage ? cFromPage : 'collate';
            console.log('contrast-clickBack----', curParams, cFromPage);

            switch(fromPage) {
                case 'contrastlist':
                    this.$router.replace('/contrastlist/'+cFromPage);
                    break;
                case 'search_result':
                    this.$router.replace('/search/result');
                    break;
                case 'search_advanced':
                    this.$router.replace('/search/advanced');
                    break;
                case 'detail':
                    this.$router.replace('/detail/record/'+detailData.id);
                    break;
                case 'detail_search_result':
                    this.$router.replace('/detail/search_result/'+detailData.id);
                    break;
                case 'detail_search_advanced':
                    this.$router.replace('/detail/search_advanced/'+detailData.id);
                    break;
                default:
                    break;
            }
        },
        timeInteractChange(e) {
            let userVip = this.$store.state.userData.vip;
            if(e && userVip == 0) {
                this.$store.state.contrast.contrastTimeInteracted = false;
                this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage:'timelimit_interact'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }
            this.$store.state.contrast.contrastTimeInteracted = e;
        },
        clickAdd() {
            let gotRecordData = this.$store.state.record.gotRecordData;
            if(!gotRecordData){
                this.$store.dispatch('record/initRecordList');
            }

            let curPath = this.$router.history.current.path;
            let bzArr = this.contrastData.bzid.split(',').map(el => {return parseInt(el)});
            setTimeout(() => {
                this.$store.dispatch('chooserecord/initChoosedMultipleItemList', {
                    bzArr: bzArr
                });
                this.$store.state.chooserecord.chooseFromPage = 'contrast';
                this.$store.state.chooserecord.chooseRecordType = 'multiple';
                this.$router.replace(curPath+'/chooserecord');
            }, 100);
        },
        clickDelete() {
            let bzArr = this.contrastData.bzid.split(',');
            if(bzArr.length <= 2) { 
                this.$toast("最少保留2个命盘");
                return; 
            }
            this.$store.state.contrast.contrastShowItemDelete = true;
        },
        clickCancelDelete() {
            this.$store.state.contrast.contrastShowItemDelete = false;
        },
        clickEdit() {
            if(this.contrastData.f_content != '') {
                this.$store.state.contrast.contrastShowCommentContent = true;
            }else {
                this.$store.state.contrast.contrastShowCommentEdit = true;
            }
        },
        clickContentBack() {
            this.$store.state.contrast.contrastShowCommentContent = false;
        },
        clickContentEdit() {
            this.$store.state.contrast.contrastShowCommentContent = false;
            this.$store.state.contrast.contrastShowCommentEdit = true;
        },
        fortuneCheckedChange(e) {
            this.$store.state.contrast.contrastShowFortune = e;
        }
    }
}
</script>
